var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "product-finish-tab": true,
        active: this.isActive
      },
      on: { click: _vm.onTabClick }
    },
    [
      _c("h3", [
        _vm._v(_vm._s(this.title) + " "),
        _vm.hasArrow
          ? _c("span", {
              staticClass: "caret caret--right",
              staticStyle: { margin: "5px 20px" }
            })
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }